"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppAnalyticsClientStub = void 0;
const EventContext_1 = require("../model/EventContext");
class AppAnalyticsClientStub {
    constructor() {
        this.isInitialized = false;
        this.context = new EventContext_1.EventContext({});
        this.disabled = false;
    }
    sendEvent(_) {
        // Do nothing
    }
    setContextProperty(_, __) {
        // Do nothing
    }
    getContextProperty(_) {
        return undefined;
    }
    setContext(_) {
        // Do nothing
    }
    getContext() {
        return {};
    }
    setUser(_, __) {
        // Do nothing
    }
    getUser() {
        return undefined;
    }
    setDisabled(_) {
        // Do nothing
    }
    isDisabled() {
        return false;
    }
}
exports.AppAnalyticsClientStub = AppAnalyticsClientStub;
//# sourceMappingURL=AppAnalyticsClientStub.js.map